import React, { useEffect, useState } from "react";
// import "./UserManagement.scss";
import { loginScreen, userPlaceholderIcon } from "assets/images";
import { Link, useParams } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import useFullPageLoader from "common/UseFullPageLoader";

import { dateFormat } from "utils/dateFormat";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import { AiOutlineDownload } from "react-icons/ai";
import usePlaceholder from "react-bootstrap/esm/usePlaceholder";
import { userPlaceholder } from "assets/icons";
import { postDetailApi, userTogglePostTrending } from "services/post";
import { IoMdArrowRoundBack } from "react-icons/io";
import useButtonLoader from "common/UseButtonLoader";

const PostDetail = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const { id } = useParams();
  const [formData, setFormData] = useState({});
  const [videoData, setVideoData] = useState("");
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [imagePreview, setImagePreview] = useState(false);
  const [tooglePostStatusModel, setTogglePostStatusModel] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  useEffect(() => {
    fetchPostDetails(id);
  }, [id]);
  const fetchPostDetails = async () => {
    try {
      const res = await postDetailApi(id);
      if (res?.data?.status === 200) {
        setFormData({
          postId: id,
          caption: res.data.data.post.caption,
          location: res.data.data.post.location,
          images: res.data.data.post.images,
          videoThumb: res.data.data.post.videoThumb,
          hashTags: res.data.data.post.hashTags,
          createdAt: res.data.data.post.createdAt,
          createrName: res.data.data.post.user.name,
          isTrend: res.data.data.post.isTrend,
        });
        setVideoData(res.data.data.post?.video?.url);
      } else {
        toastMessage(res?.data?.message, "error", "postDetail");
      }
    } catch (e) {
      toastMessage(e.message, "error", "postDetail");
    }
  };

  function getActionMessage(key, value) {
    console.log("key", key);
    const normalized = String(key).toLowerCase() === "true";

    console.log(normalized, "normalize");

    const messages = {
      isTrend: normalized ? "Remove Trending" : "Make Trending",
      trendingStatement: normalized
        ? "Are you sure you want to remove this post from Trending?"
        : "Are you sure you want to make this post to Trending?",
    };

    return messages[value] || "Are you sure you want to perform this action?";
  }

  const togglePostTrendingStatus = async () => {
    try {
      setButtonLoader(true);
      const sendData = {
        postId: id,
        isTrend: !formData?.isTrend,
      };
      const res = await userTogglePostTrending(sendData);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changePostStatus");
        setButtonLoader(false);
        fetchPostDetails();
        setTogglePostStatusModel(false);
      } else {
        toastMessage(res.data.message, "error", "changePostStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  console.log("formData", formData);

  return (
    <>
      {loader}
      <div className="editProfile user_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3>
              <Link to={"/post-management"}>
                <IoMdArrowRoundBack />
              </Link>{" "}
              Post details
            </h3>
            {String(formData?.isTrend) && (
              <div class="d-flex">
                <button
                  variant="contained"
                  class="button button mx-2"
                  type="button"
                  onClick={() => setTogglePostStatusModel(true)}
                >
                  {getActionMessage(formData?.isTrend, "isTrend")}
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="personal_details _box spacing">
              <div className="details_list">
                <ul>
                  <li>
                    <b>Name</b>
                    <span>{formData?.createrName}</span>
                  </li>
                  {/* <li>
                                        <b>Type</b>
                                        <span>{formData?.hashTags}</span>
                                    </li> */}
                  <li>
                    <b>HashTag</b>
                    <span>{formData?.hashTags}</span>
                  </li>
                  <li>
                    <b>Location</b>
                    <span>{formData?.location}</span>
                  </li>
                  <li>
                    <b>Caption</b>
                    <span
                      dangerouslySetInnerHTML={{ __html: formData?.caption }}
                    />
                  </li>
                  <li>
                    <b>Created On</b>
                    <span>{dateFormat(formData?.createdAt)}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab_content">
              <div className="post_details">
                {/* Render post data */}
                <div className="post_item">
                  {formData.images && formData.images.length > 0 ? (
                    <>
                      <div className="image_gallery">
                        <ul className="image_list">
                          {formData?.images.map((image, imageIndex) => (
                            <li
                              key={image._id || imageIndex}
                              onClick={() => {
                                setImagePreview(true);
                                setImageUrl(image?.url);
                              }}
                            >
                              <img
                                src={image.url}
                                alt={`Post ${imageIndex + 1} - Image ${
                                  imageIndex + 1
                                }`}
                                className="post_image"
                              />
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <div className="image_gallery">
                      <ul className="image_list">
                        <li>
                          <label className="label">Post</label>
                          <video
                            src={
                              formData.video ? formData.video.url : videoData
                            }
                            controls
                            width="300"
                          />
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
        className={"image_preview_modal"}
      >
        <img src={imageUrl ? imageUrl : loginScreen} alt="" />
      </CustomModal>

      <PopupModal
        show={tooglePostStatusModel}
        handleClose={() => setTogglePostStatusModel(false)}
        content={getActionMessage(formData?.isTrend, "trendingStatement")}
        title="Change Post Trending Status"
        onShow={togglePostTrendingStatus}
        buttonLoader={buttonLoader}
      />
    </>
  );
};

export default PostDetail;
